import React from 'react';
import { connect } from 'react-redux';

import ErrorPage from './components/ErrorPage';
import TrackingPage from './pages/TrackingPage';

export class App extends React.PureComponent {
  render() {
    const {
      isPreview,
      isDummy,
      tracking: { data: trackingData, loaded: isLoaded },
      settings: {
        settings: { widgets, settings: designSettings } = {},
        error: settingsError,
      },
      language,
      onChangeLanguage,
    } = this.props;

    if (!isLoaded) {
      return null;
    }

    const errorType = getErrorType({ trackingData, settingsError });

    if (errorType) {
      return <ErrorPage type={errorType} language={language} />;
    }

    return (
      <TrackingPage
        isPreview={isPreview}
        isDummy={isDummy}
        widgets={widgets}
        designSettings={designSettings}
        onChangeLanguage={onChangeLanguage}
      />
    );
  }
}

function getErrorType({ trackingData, settingsError }) {
  if (settingsError) {
    // if fetching widget settings failed it doesn't matter what is going on with tracking data
    return settingsError.status === 404 ? 'not-found': 'error';
  }

  if (!trackingData) {
    return 'no-info';
  }

  return null;
}

function mapStateToProps(state) {
  const { tracking, settings, language } = state;

  return {
    tracking,
    settings,
    language,
  };
}

export default connect(mapStateToProps)(App);
